<template>
  <div class="chart-block">
      <div class="chart-container" :id="chartId" :style="{'width': chartWidth,'height': chartHeight}"></div>
  </div>
</template>
<script>
let echarts = require('echarts/lib/echarts');
// 引入柱状图
require('echarts/lib/chart/line');
require('echarts/lib/component/title');
require('echarts/lib/component/tooltip');
require('echarts/lib/component/legend');
import {GridComponent} from 'echarts/components';
echarts.use([GridComponent]);

export default {
  name: 'Line01',
  props: {
    chartId:{
      type: String,
      default: 'chart-id'
    },
    mainId:{
      type:Number,
      default:-1
    },
    chartWidth: {
      type: String,
      default: '0px'
    },
    chartHeight: {
      type: String,
      default: '0px'
    },
    title: {
      type: String,
      default: ''
    },
    legendShow: {
      type: Boolean,
      default: true
    },
    legendGroup: {
      type: Array,
      default: function(){
        return []
      }
    },
    xLabel: {
      type: Array,
      default: function(){
        return ['1月','2月','3月','4月','5月','6月']
      }
    },
    yData: {
      type: Array,
      default: function(){
        return [[5, 20, 36, 10, 10, 20],[15, 22, 46, 20, 30, 50]]
      }
    },
    colorSet: {
      type:Array,
      default:function(){
        return ['#675bba', '#5793f3','#5793f3', '#d14a61','#d14a61', '#675bba']
      }
    }
  },
  data() {
    return {
      chart: null,
    }
  },
  created: function() {

    //this.drawLine();
  },
  mounted() {
    console.log("mounted is created");
    this.$emit("queryPage",{chartId:this.chartId,id:this.mainId});
  },
  methods: {
    drawLine(labelX,dataY) {
      this.xLabel=labelX;
      this.yData=dataY;
      //console.log("drawLine is begining");
      //console.log("drawLine is begining:"+JSON.stringify(this.xLabel));
      let colors =this.colorSet;
      let legendGroup=this.legendGroup;
      let xLabelGroup=this.xLabel;
      let yCount=this.yData.length;
      if(legendGroup.length<yCount){
        let yOtherCount=yCount-legendGroup.length;
        for(let i=1;i<=yOtherCount;i++){
          legendGroup.push("");
        }
      }

      let seriesGroup=[];

      for(let i=0;i<yCount;i++){
        let seriesObj={};
        seriesObj.name= legendGroup[i];
        seriesObj.type= 'line';
        seriesObj.data= this.yData[i];
        seriesGroup.push(seriesObj);
      }

      let options = {
        title: {
          text: this.title,
          textStyle: {
                fontSize: 12,
                fontStyle: 'normal',
                fontWeight: 'bolder',
          },
          padding:2
        },
        grid:{
          top:30,
          x:24,
          x2:0,
          y2:20,
        },
        tooltip: {
          trigger: 'axis',
          formatter: "<div style='text-align:left;'>日期: {b}<br/>价格: {c}</div>"
        },
        color: colors,
        legend: {
          data: this.legendShow?legendGroup:[]
        },
        xAxis: {
          data: this.xLabel
        },
        yAxis: {},
        series: seriesGroup
      }
      this.chart = echarts.init(document.getElementById(this.chartId));
      this.chart.setOption(options);
    }
  }
}
</script>
<style>
.chart-block {
  padding:10px;
  background:#fff;
}

.chart-container{
  background:#fff;
}

.item-action li:before {
  content: "样式：";
}
</style>



// WEBPACK FOOTER //
// src/components/chart/Line01.vue